import { ContentWrapper } from '@/components/ContentWrapper';
import { ConsentsTable } from './ConsentsTable';
import { SubscriptionDetails } from './SubscriptionDetails';
import { PageHeading } from '@/typography/Typography';
import { AddOnTable } from './AddOnTable';
import { EmployeeSigningDocuments } from './documents/EmployeeSigningDocuments';
import { useCurrentCompanyDetails } from '@/services/paymentsQuery';

export const SubscriptionPage = () => {
    const { data } = useCurrentCompanyDetails();

    return (
        <ContentWrapper>
            <>
                <PageHeading>Subscription</PageHeading>
                <SubscriptionDetails />
                <AddOnTable />
                <ConsentsTable />
                {data?.data?.enableInstaSign && <EmployeeSigningDocuments />}
            </>
        </ContentWrapper>
    );
};
